<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ 'horses.form.editTitle' | translate }}</h2>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <div class="row">
      <h3>{{ 'horses.form.baseInfo' | translate }}</h3>
      <p class="text-muted small mb-3">{{ 'horses.form.requiredFieldsPrefix' | translate }} <span class="text-danger">*</span> {{ 'horses.form.requiredFieldsSuffix' | translate }}</p>
    </div>

    <div class="row spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="('horses.form.horseName' | translate) + ' *'"
          [type]="'text'"
          [placeholder]="'horses.form.horseNamePlaceholder' | translate"
          [(value)]="name"
          [invalid]="isNameInvalid"
        />
      </div>
    </div>

    <div class="row g-4 spacing-15">
      <div class="col-lg-6 col-12">
        <app-selectorini
          [options]="horseGenders"
          [label]="('horses.form.gender' | translate) + ' *'"
          [placeholder]="'horses.form.genderPlaceholder' | translate"
          [multiple]="false"
          [(value)]="selectedGender"
          [invalid]="isGenderInvalid"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="('horses.form.dateOfBirth' | translate) + ' *'"
          [type]="'date'"
          [placeholder]="'horses.form.dateOfBirthPlaceholder' | translate"
          [(value)]="date_of_birth"
          [invalid]="isDateOfBirthInvalid"
        />
      </div>
    </div>

    <div class="row g-4 spacing-30">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'horses.form.breed' | translate"
          [type]="'text'"
          [placeholder]="'horses.form.breedPlaceholder' | translate"
          [(value)]="breed"
        />
      </div>
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'horses.form.color' | translate"
          [type]="'text'"
          [placeholder]="'horses.form.colorPlaceholder' | translate"
          [(value)]="color"
        />
      </div>
    </div>

    <div class="row">
      <h3>{{ 'horses.form.registration' | translate }}</h3>
    </div>
    <div class="row g-4 spacing-30">
      <div class="col-lg-6 col-12 pb-0 mb-0">
        <app-input-component
          [label]="('horses.form.passportNumber' | translate) + ' *'"
          [type]="'text'"
          [placeholder]="'horses.form.passportPlaceholder' | translate"
          [(value)]="passport_id"
          [invalid]="isPassportIdInvalid"
        />
      </div>

      <div class="col-lg-6 col-12">
        <app-selectorini
          [options]="horseRegistries"
          [label]="'horses.form.registry' | translate"
          [placeholder]="'horses.form.registryPlaceholder' | translate"
          [(value)]="selectedRegistry"
        />
      </div>
    </div>

    <div class="row mt-4">
      <h3>{{ 'horses.form.vaccination' | translate }}</h3>
    </div>

    <div class="row g-4 spacing-30">
      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'horses.form.vaccinationDate' | translate"
          [type]="'date'"
          [placeholder]="'horses.form.vaccinationDatePlaceholder' | translate"
          [(value)]="vaccination_date"
        />
      </div>

      <div class="col-lg-6 col-12">
        <app-input-component
          [label]="'horses.form.nextVaccinationDate' | translate"
          [type]="'date'"
          [placeholder]="'horses.form.nextVaccinationPlaceholder' | translate"
          [(value)]="next_vaccination_date"
        />
      </div>
    </div>

    <div class="row g-4 spacing-30">
      <div class="col-lg-4 col-12">
        <h4>{{ 'horses.form.horseImage' | translate }}</h4>
        @if (currentHorseImage) {
          <div class="image-preview-container">
            <img [src]="currentHorseImage" alt="Horse image" class="image-preview" />
            <div class="image-overlay">
              @if (horseImagePreview) {
                <button type="button" class="btn-image-action" (click)="clearHorseImageSelection()" [title]="'common.cancel' | translate">
                  <i class="fa fa-undo"></i>
                </button>
              }
              <label class="btn-image-action" [title]="'horses.form.changeImage' | translate">
                <i class="fa fa-camera"></i>
                <input type="file" accept="image/*" class="d-none" (change)="onHorseImageSelected($any($event.target).files)" />
              </label>
            </div>
            @if (horseImagePreview) {
              <span class="new-badge">{{ 'horses.form.new' | translate }}</span>
            }
          </div>
        } @else {
          <app-fileorini
            [accept]="'image/*'"
            (filesChanged)="onHorseImageSelected($event)"
          />
        }
      </div>

      <div class="col-lg-4 col-12">
        <h4>{{ 'horses.form.pedigree' | translate }}</h4>
        @if (currentPedigreeImage) {
          <div class="image-preview-container">
            <img [src]="currentPedigreeImage" alt="Pedigree" class="image-preview" />
            <div class="image-overlay">
              @if (pedigreePreview) {
                <button type="button" class="btn-image-action" (click)="clearPedigreeSelection()" [title]="'common.cancel' | translate">
                  <i class="fa fa-undo"></i>
                </button>
              }
              <label class="btn-image-action" [title]="'horses.form.changeImage' | translate">
                <i class="fa fa-camera"></i>
                <input type="file" accept="image/*" class="d-none" (change)="onPedigreeSelected($any($event.target).files)" />
              </label>
            </div>
            @if (pedigreePreview) {
              <span class="new-badge">{{ 'horses.form.new' | translate }}</span>
            }
          </div>
        } @else {
          <app-fileorini
            [accept]="'image/*'"
            (filesChanged)="onPedigreeSelected($event)"
          />
        }
      </div>

      <div class="col-lg-4 col-12">
        <h4>{{ 'horses.form.vaccinationCard' | translate }}</h4>
        @if (currentVaccinationCard) {
          <div class="image-preview-container">
            <img [src]="currentVaccinationCard" alt="Vaccination card" class="image-preview" />
            <div class="image-overlay">
              @if (vaccinationCardPreview) {
                <button type="button" class="btn-image-action" (click)="clearVaccinationCardSelection()" [title]="'common.cancel' | translate">
                  <i class="fa fa-undo"></i>
                </button>
              }
              <label class="btn-image-action" [title]="'horses.form.changeImage' | translate">
                <i class="fa fa-camera"></i>
                <input type="file" accept="image/*" class="d-none" (change)="onVaccinationCardSelected($any($event.target).files)" />
              </label>
            </div>
            @if (vaccinationCardPreview) {
              <span class="new-badge">{{ 'horses.form.new' | translate }}</span>
            }
          </div>
        } @else {
          <app-fileorini
            [accept]="'image/*'"
            (filesChanged)="onVaccinationCardSelected($event)"
          />
        }
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-12 d-flex justify-content-end">
        <app-button
          [variant]="'primary'"
          [label]="saving ? ('horses.form.saving' | translate) : ('horses.form.save' | translate)"
          [iconClass]="saving ? 'fa fa-spinner fa-spin' : 'fa fa-save'"
          [disabled]="saving"
          (clicked)="onSave()"
        />
      </div>
    </div>
  </div>
</div>
